import type { FolderReference } from '@speechifyinc/multiplatform-sdk';

import { SDKContentSubType } from '../analytics/contentSubType';
import { MultiplatformSDKInstance } from '../sdk';
import { SDKFacade } from './_base';

export class SDKImportFacade extends SDKFacade {
  private static _singleton: SDKImportFacade;
  constructor(sdk: MultiplatformSDKInstance) {
    super(sdk);
    SDKImportFacade._singleton = this;
  }

  static override get singleton(): SDKImportFacade {
    return SDKImportFacade._singleton;
  }

  public importFileFromURL = async ({
    url,
    folderReference,
    title,
    contentSubType,
    importFlow
  }: {
    url: string;
    folderReference?: FolderReference;
    title?: string;
    contentSubType: SDKContentSubType;
    importFlow?: 'pill-player';
  }) => {
    const WebBoundaryMap = this.sdk.WebBoundaryMap;
    const { ImportFlow, ImportOptions, ImportableContentMetadata } = this.sdk.sdkModule;
    const _importFileFromURL = this.sdk.promisify(this.sdk.client.importService.importFileFromURL.bind(this.sdk.client.importService));
    const sdkImportFlow = importFlow === 'pill-player' ? ImportFlow.PillPlayer : undefined;
    const task = _importFileFromURL(
      url,
      new ImportOptions(title, folderReference, new WebBoundaryMap({ prop: 'value' })),
      new ImportableContentMetadata(contentSubType, sdkImportFlow)
    );
    return task;
  };
}
